import { HeroPhoto } from './HeroPhoto';
import { contacts } from '../config/site';

export function Hero() {
  return (
    <section className="hero section-axis" id="top" aria-labelledby="hero-title">
      <div className="hero-layout page-shell">
        <div className="hero-copy">
          <span className="eyebrow" data-enter="eyebrow">ALEXADS / LATVIA</span>
          <h1 className="hero-title" id="hero-title" aria-label="Помогаю бизнесу расти." data-enter="title">
            <span>Помогаю</span>
            <span>бизнесу</span>
            <em>расти.</em>
          </h1>
          <p className="hero-intro" data-enter="intro">Реклама, сайты и аналитика, которые помогают привлекать клиентов и принимать понятные решения.</p>
          <a className="primary-action action-link" href={contacts.emailHref} data-enter="cta">Обсудить проект <span aria-hidden="true">→</span></a>
        </div>

        <HeroPhoto />

        <div className="hero-disciplines" data-enter="meta">
          <span aria-hidden="true" />
          <p>Маркетинг<br />Сайты<br />Продукты<br />Развитие</p>
        </div>
      </div>
    </section>
  );
}
